module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABX0lEQVRYR+2YQUrDQBSG/xcDImndeQI9gJseINKCNEk3Qg/g3oXLCm4UdOnCvQcouOkkRWwwB3ChB9ATuEtaipDmybRGipukpOAIk9VA3vzz8+WfIW8IS8+wP9zJtswTgDyAdgGuL7+vPqYE4HeAhTFNb9vd9keuSfkgGIyOmPgOoO3qC5ZR4JiYjp1O615Wz40sTKAPwCCQYEpvLGvz2bbtcRnJsjVRFNUmk88GsXnKYA9ARoyuNEPfn+NNkiCDzhyneV1WuEpdEIQ9zvgK4NiYpnvki8cLgM4lCcdrdqqIrzo3EOFgQYYvyRejFwD7oNmB6x5Gq4pVqff9Bxu88QTglXwRxnJ3WDWzvu5MFJmcZ2acJgAlkgjLCa7X+tlBRQLrfJ+vr43kVDWR3/nSRDSRojNHZ0RnRGekiIDOSBEhfY78h4yo8/OsSjuhSIOlTMupTBOu1LVEbuYvL2q+AI/pVG6nzB8ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fenxiao/fx_choose_sport_no.png
// module id = RnTe
// module chunks = 0